//import {Container, Col, Row }from 'react-bootstrap';

function ContentNDRCProjectText(){
    return (
        <> 
            <p className="py-0 text-start font-body color-font-primary font-size-large">Not Dallas Run Club: nDRC</p>
            <p className="py-0 text-start font-body color-font-primary font-size-small">2020, the year COVID and running swept the nation. What started as group of friends socializing through one of the few socially acceptable ways to gather became a gateway to the larger road running community.</p>

            <p className="py-0 text-start font-body color-font-primary font-size-small">The group, which would later call themselves the NOT Dallas Run Club - consisting of a majority of transplants to the city of Dallas, that would meet up Saturdays to run.  What started out a tongue in cheek moniker was made more official with an original negative space design logo and a handful of merch</p>

        </>
    )
}

export default ContentNDRCProjectText;